import React from 'react';
import { Button, Form, FormGroup, Input, Label, FormFeedback } from 'reactstrap';
import { campaignChargesValidations } from 'form-validations';
import { connect } from 'react-redux';
import { CampaignAction } from 'redux/actions';


const AddChargeForm = (props) => {

    let [values, setValues] = React.useState({});
    let [errors, setErrors] = React.useState({});
    let [isSubmitted, setIsSubmitted] = React.useState(false);
    let [isValid, setIsValid] = React.useState(true);

    React.useEffect(() => {
        const obj = { id: props.selectedCharge[0], goal: props.selectedCharge[1], value: props.selectedCharge[2] };
        setValues(obj)
    }, [props.selectedCharge]);

 

    React.useEffect(() => {
        const validationErrors = campaignChargesValidations(values);
        isValid = Object.keys(validationErrors).length === 0;
        setIsValid(isValid);
        setErrors(validationErrors);
    }, [values]);

    

    const handleChange = (event) => {
        setValues({
            ...values, [event.target.name]: event.target.value
        })
    };

    const handleSubmit = () => {
        setIsSubmitted(true);
        if (isValid) {
            props.saveCampaignCharges(values);
        }
    }

    /*React.useEffect(() => {
        setIsSubmitted(false);
    }, [groupAdded]);*/

    return (
        <div>
            <Form>

                <FormGroup>
                    <Label for={'goal'}>{'Goal'}</Label>
                    <Input
                        type="select"
                        name="goal"
                        id="goal"
                        onChange={handleChange}
                        autoComplete={'off'}
                        value={(values && values.goal) ? values.goal : ''}
                    >
                        <option>select</option>
                        <option value={'clicks'}>Clicks</option>
                        <option value={'impressions'}>Impressions</option>
                    </Input>
                    {(isSubmitted && errors.goal && !values.goal) && <FormFeedback >{errors.goal} </FormFeedback>}
                </FormGroup>

                <FormGroup>
                    <Label for={'value'}>{'Charges amount'}</Label>
                    <Input
                        type="text"
                        name="value"
                        id="value"
                        onChange={handleChange}
                        autoComplete={'off'}
                        value={(values && values.value) ? values.value : ''}
                    />
                    {(isSubmitted && errors.value && !values.value) && <FormFeedback >{errors.value} </FormFeedback>}
                </FormGroup>

                <Button
                    size="sm"
                    color="primary"
                    className="border-0"
                    block
                    onClick={handleSubmit} >
                    {props.selectedCharge && props.selectedCharge[0] ? 'Edit Campaign Charge' : 'Add Campaign Charge'}
                </Button>
            </Form>
        </div>
    );
};

const mapStateToProps = (state) => ({
    isLoading: (state.uiReducer && state.uiReducer.isLoading) ? state.uiReducer.isLoading : false,
    groupAdded: (state.groups && state.groups.groupAdded) ? state.groups.groupAdded : {},
})

const mapDispatchToProps = (dispatch) => ({
    saveCampaignCharges: (payload) => dispatch(CampaignAction.saveCampaignCharges(payload))
})



export default connect(mapStateToProps, mapDispatchToProps)(AddChargeForm);